/* eslint-disable no-console */

export const isDev = (): boolean => import.meta.env.DEV

export const isProd = (): boolean => import.meta.env.PROD

export const log = (...args: unknown[]): void => {
  if (isDev()) {
    console.log(...args)
  }
}

export const warn = (...args: unknown[]): void => {
  if (isDev()) {
    console.warn(...args)
  }
}

export const error = (...args: unknown[]): void => {
  if (isDev()) {
    console.error(...args)
  }
}

export const isIOS = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window)
